<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import store from "@/store";
import { getToken } from "@/utils/auth";

export default {
  name: "App",

  data() {
    return {
      dialogVisible: true,
    };
  },
  created() {},

  mounted() {
    let that = this;
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState == "visible") {
        if (store.getters.NIM && getToken()) {
          store.dispatch("initNIM");
        }
      }
    });
  },
  methods: {},
};
</script>
<style type="text/css">
*{
  word-break: break-all;
}
/*//去除amap 地图 logo*/
  .amap-logo{
    display: none;
    opacity:0 !important;
  }
  .amap-copyright {
    opacity:0;
  }
  /*/
/添加弹出框额外样式 / .my_project_popover {
  padding: 16px 24px;
  padding-right: 4px;
  height: 528px !important;
  overflow-x: hidden;
  overflow-y: auto;
}
.popoverBox {
  padding-right: 20px;
}
.popover {
  height: 240px !important;
  overflow-y: auto;
  padding: 8px 0;
}
/* 自定义滚动条整体样式 */
.el-popover ::-webkit-scrollbar {
  width: 4px; /* 设置滚动条的宽度 */
  border: none;
}

/* 自定义滚动条滑块样式 */
.el-popover ::-webkit-scrollbar-thumb {
  background-color: #eff0f3; /* 设置滑块的颜色 */
  border-radius: 4px; /* 设置滑块的圆角 */
}

/* 自定义滚动条轨道样式 */
.el-popover ::-webkit-scrollbar-track {
  background-color: transparent; /* 设置轨道的颜色 */
  border: none;
}

.notificationPopover {
  width: none !important;
  top: -1000px !important;
}
.el-popper {
  /* width: 196px; */
}
.has-time{
  /* width: none !important; */
}
.el-popconfirm__main {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #606266;
  line-height: 20px;
}
.el-popper .el-button--text {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #3860e2;
}
</style>



// WEBPACK FOOTER //
// src/App.vue